import MembersApi, { ListingMember } from '@app/api/public/MembersApi';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { L } from '../../../lib/i18n';
import z from 'zod';
import { propertiesQueryKeys } from './propertyQueries';

const errorSchema = z.object({ email: z.string(), status: z.string() }).array();

const inviteMember = async ({ memberArray }: { memberArray: ListingMember[] }) => {
    const response = await Promise.all(
        memberArray.map(async (member) => {
            try {
                const response = await MembersApi.inviteMember(member.id);
                if (response.status === 'error') return { email: member.email, status: response.status };
                return { email: member.email, status: 'success' };
            } catch (error) {
                return { email: member.email, status: 'unknown' };
            }
        })
    );
    //throw new Error(`Inbjudan kunde inte skickas till ${response.email}`);
    const errors = response.find((item) => item.status === 'error' || item.status === 'unknown');
    if (errors) throw response;
};
const useInviteCheckedMembers = (id: number) => {
    const queryClient = useQueryClient();
    return useMutation(inviteMember, {
        onSuccess: () => {
            toast(`✅ ${L('invite_sent')}`);
        },
        onError: (err) => {
            console.log(err);

            const validatedError = errorSchema.safeParse(err);
            /* Shows error message  */
            if (validatedError.success) {
                const errors = validatedError.data.filter(
                    (item) => item.status === 'error' || item.status === 'unknown'
                );
                errors.map((item) => {
                    toast.error(`Inbjudan gick inte att skicka till ${item.email}`);
                });
                const success = validatedError.data.filter((item) => item.status === 'success');
                success.length && toast.success(`${success.length} medlemmar inbjudna`);
            }
        },
        onSettled: () => {
            queryClient.invalidateQueries([propertiesQueryKeys.detail(id)]);
        },
    });
};

export default useInviteCheckedMembers;
